<template>
  <div class="d-flex align-center ga-2">
    <v-skeleton-loader
      type="button"
      class="actions-skeleton-button actions-skeleton-download"
    />
    <v-skeleton-loader
      type="button"
      class="actions-skeleton-button actions-skeleton-primary"
    />
  </div>
</template>

<style lang="less" scoped>
.actions-skeleton-button {
  flex-shrink: 0;

  :deep(.v-skeleton-loader) {
    background: transparent;
    height: 36px;
  }

  :deep(.v-skeleton-loader__bone),
  :deep(.v-skeleton-loader__button) {
    margin: 0;
    height: 36px;
    min-height: 36px;
    border-radius: 8px;
  }
}

.actions-skeleton-download {
  :deep(.v-skeleton-loader),
  :deep(.v-skeleton-loader__bone),
  :deep(.v-skeleton-loader__button) {
    width: 140px;
    min-width: 140px;
  }
}

.actions-skeleton-primary {
  :deep(.v-skeleton-loader),
  :deep(.v-skeleton-loader__bone),
  :deep(.v-skeleton-loader__button) {
    width: 200px;
    min-width: 200px;
  }
}
</style>
